import { useQuery } from "@tanstack/react-query";
import { fetchUserByUIdV2 } from "../api/index.v2";
export const useFetchUserByUId = (uuid?: string, enabled?: boolean) => {
  const {
    data: userData,
    isError: isErrorUser,
    isLoading: isLoadingUser,
  } = useQuery({
    queryKey: ["getUserByIdV2", uuid],
    queryFn: () => (uuid ? fetchUserByUIdV2(uuid) : undefined),
    enabled: !!uuid && enabled,
    refetchOnWindowFocus: false,
  });

  return {
    userData,
    isErrorUser,
    isLoadingUser,
  };
};
